import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
export default function LoginRename() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [timer, setTimer] = useState(0);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((p) => p - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleSendOtp = async (e) => {
    e?.preventDefault();
    if (!email || !password) { toast.error("Please enter email and password"); return; }
    try {
      const res = await fetch(`{API}/api/admin/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (res.ok) { toast.success("OTP sent to your email 📩"); setStep(2); setTimer(60); }
      else toast.error(data.message || "Failed to send OTP");
    } catch { toast.error("Server error. Try again later"); }
  };

  const handleVerifyOtp = async (e) => {
    e?.preventDefault();
    if (!otp) { toast.error("Please enter OTP"); return; }
    try {
      const res = await fetch(`{API}/api/admin/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });
      const data = await res.json();
      if (res.ok) {
        toast.success("Login successful 🎉");
        localStorage.setItem("adminToken", data.token);
        setTimeout(() => navigate("/admin"), 1500);
      } else toast.error(data.message || "Invalid OTP");
    } catch { toast.error("Server error. Try again"); }
  };

  return (
    <>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }

        .login-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #EFF6FF;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .login-card {
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #BFDBFE;
          padding: 44px 40px 40px;
          width: 100%;
          max-width: 400px;
          box-shadow: 0 4px 24px rgba(59, 130, 246, 0.08);
        }

        .logo-wrap {
          width: 44px;
          height: 44px;
          background: #3B82F6;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
        }
        .logo-wrap svg { width: 22px; height: 22px; fill: #fff; }

        .login-title {
          font-size: 20px;
          font-weight: 600;
          color: #1e3a5f;
          margin-bottom: 4px;
        }
        .login-sub {
          font-size: 13.5px;
          color: #93A8C4;
          margin-bottom: 30px;
        }

        .field { margin-bottom: 16px; }
        .field label {
          display: block;
          font-size: 12.5px;
          font-weight: 500;
          color: #4A6FA5;
          margin-bottom: 6px;
        }
        .field input {
          width: 100%;
          padding: 10px 14px;
          font-size: 14px;
          color: #1e3a5f;
          background: #F8FBFF;
          border: 1.5px solid #BFDBFE;
          border-radius: 8px;
          outline: none;
          transition: border-color 0.15s, background 0.15s;
        }
        .field input:focus {
          border-color: #3B82F6;
          background: #fff;
        }
        .field input::placeholder { color: #BFDBFE; }

        .otp-input {
          letter-spacing: 8px;
          font-size: 20px !important;
          font-weight: 600;
          text-align: center;
          color: #3B82F6 !important;
        }

        .btn-main {
          width: 100%;
          padding: 11px;
          background: #3B82F6;
          color: #fff;
          border: none;
          border-radius: 8px;
          font-size: 14.5px;
          font-weight: 600;
          cursor: pointer;
          margin-top: 8px;
          transition: background 0.15s;
          letter-spacing: 0.2px;
        }
        .btn-main:hover { background: #2563EB; }

        .btn-resend {
          width: 100%;
          padding: 10px;
          background: #EFF6FF;
          color: #3B82F6;
          border: 1.5px solid #BFDBFE;
          border-radius: 8px;
          font-size: 13.5px;
          font-weight: 500;
          cursor: pointer;
          margin-top: 10px;
          transition: all 0.15s;
        }
        .btn-resend:not(:disabled):hover {
          background: #DBEAFE;
          border-color: #93C5FD;
        }
        .btn-resend:disabled {
          color: #93C5FD;
          cursor: not-allowed;
        }

        .otp-hint {
          font-size: 12px;
          color: #93A8C4;
          text-align: center;
          margin-top: 16px;
        }
        .otp-hint span {
          color: #3B82F6;
          font-weight: 500;
        }

        .divider {
          border: none;
          border-top: 1px solid #EFF6FF;
          margin: 24px 0 0;
        }
        .footer {
          font-size: 11.5px;
          color: #BFDBFE;
          text-align: center;
          margin-top: 16px;
        }
      `}</style>

      <div className="login-page">
        <div className="login-card">

          <div className="logo-wrap">
            <svg viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.25 3.75 10.15 9 11.25C17.25 21.15 21 16.25 21 11V5L12 1z" /></svg>
          </div>

          {step === 1 ? (
            <>
              <div className="login-title">Admin Login</div>
              <div className="login-sub">Enter your credentials to receive an OTP</div>
              <form onSubmit={handleSendOtp}>
                <div className="field">
                  <label>Email address</label>
                  <input type="email" placeholder="admin@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className="field" style={{ position: "relative" }}>
                  <label>Password</label>

                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ paddingRight: "40px" }}
                  />

                  {/* Eye Icon */}
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "36px",
                      cursor: "pointer",
                      fontSize: "16px",
                      color: "#3B82F6"
                    }}
                  >
                    {showPassword ? "🙈" : "👁️"}
                  </span>
                </div>
                <button type="submit" className="btn-main">Send OTP</button>
              </form>
            </>
          ) : (
            <>
              <div className="login-title">Enter your code</div>
              <div className="login-sub">We sent a 6-digit code to your email</div>
              <form onSubmit={handleVerifyOtp}>
                <div className="field">
                  <label>One-time password</label>
                  <input
                    type="text"
                    placeholder="——————"
                    className="otp-input"
                    maxLength={6}
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                  />
                </div>
                <button type="submit" className="btn-main">Verify & Sign In</button>
                <button
                  type="button"
                  className="btn-resend"
                  disabled={timer > 0}
                  onClick={handleSendOtp}
                >
                  {timer > 0 ? `Resend code in ${timer}s` : "Resend OTP"}
                </button>
              </form>
              <p className="otp-hint">Code sent to <span>{email}</span></p>
            </>
          )}

          <hr className="divider" />
          <p className="footer">Secured · Admin Portal</p>
        </div>
      </div>
    </>
  );
}